import axios from "axios";
import { PENDINGISSUE } from "../_constants/actionConstants";
import { BASE_URL } from "../_constants/urlConstants";
import raiseError from "./raiseError";
import raiseWarning from "./raiseWarning";

const add = (newPiData) => async (dispatch) => {
  dispatch({ type: PENDINGISSUE.ADD });
  const apiEndpoint = `${BASE_URL}/api/PendingIssues`;
  try {
    const res = await axios.post(apiEndpoint, newPiData);
    if (res.data.message) {
      dispatch({ type: PENDINGISSUE.ADD_REJECTED });
      raiseWarning(PENDINGISSUE.ADD_REJECTED, res.data.message);
      return null;
    }
    dispatch({
      type: PENDINGISSUE.ADD_FULFILLED,
      projectId: newPiData.projectId,
    });
    return res.data.newPendingIssueId;
  } catch (err) {
    dispatch({ type: PENDINGISSUE.ADD_REJECTED });
    raiseError(PENDINGISSUE.ADD_REJECTED, err.response.data);
  }
};

const deletePendingIssue = (pendingIssueId, projectId) => async (dispatch) => {
  dispatch({ type: PENDINGISSUE.DELETE });
  const apiEndpoint = `${BASE_URL}/api/PendingIssues/${pendingIssueId}/${projectId}`;
  try {
    await axios.delete(apiEndpoint);
    dispatch({ type: PENDINGISSUE.DELETE_FULFILLED });
    dispatch({ type: PENDINGISSUE.CLEAR_DETAILS, projectId, pendingIssueId });
    return;
  } catch (err) {
    dispatch({ type: PENDINGISSUE.DELETE_REJECTED });
    raiseError(PENDINGISSUE.DELETE_REJECTED, err.response.data);
  }
};

const getDetails = (pendingIssueId, projectId) => async (dispatch) => {
  dispatch({ type: PENDINGISSUE.FETCH_DETAILS });
  const apiEndpoint = `${BASE_URL}/api/PendingIssues/${pendingIssueId}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: PENDINGISSUE.FETCH_DETAILS_FULFILLED,
      pendingIssueId,
      projectId,
      pendingIssueDetails: res.data,
    });
    return;
  } catch (err) {
    dispatch({ type: PENDINGISSUE.FETCH_DETAILS_REJECTED });
    raiseError(PENDINGISSUE.FETCH_DETAILS_REJECTED, err.response.data);
  }
};

const getAll = (projectId) => async (dispatch) => {
  dispatch({ type: PENDINGISSUE.FETCH_ALL });
  const apiEndpoint = `${BASE_URL}/api/PendingIssues/List/${projectId}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: PENDINGISSUE.FETCH_ALL_FULFILLED,
      projPendingIssueList: res.data.projPendingIssueList,
    });
    return;
  } catch (err) {
    dispatch({ type: PENDINGISSUE.FETCH_ALL_REJECTED });
    raiseError(PENDINGISSUE.FETCH_ALL_REJECTED, err.response.data);
  }
};

const update = (pendingIssueDto) => async (dispatch) => {
  dispatch({ type: PENDINGISSUE.EDIT });
  const apiEndpoint = `${BASE_URL}/api/PendingIssues`;
  try {
    const res = await axios.put(apiEndpoint, pendingIssueDto);
    if (res.data.message) {
      dispatch({ type: PENDINGISSUE.EDIT_REJECTED });
      raiseWarning(PENDINGISSUE.EDIT_REJECTED, res.data.message);
    }
    dispatch({
      type: PENDINGISSUE.EDIT_FULFILLED,
      pendingIssueDetails: res.data.pendingIssueDetails,
    });
    return true;
  } catch (err) {
    dispatch({ type: PENDINGISSUE.EDIT_REJECTED });
    raiseError(PENDINGISSUE.EDIT_REJECTED, err.response.data);
  }
};

const hasLinks = (pendingIssueId) => async (dispatch) => {
  dispatch({ type: PENDINGISSUE.GENERIC_REQUEST });
  const apiEndpoint =
    BASE_URL + "/api/PendingIssues/HasLinks/?pendingIssueId=" + pendingIssueId;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: PENDINGISSUE.GENERIC_REQUEST_FULFILLED });
    return res.data;
  } catch (err) {
    dispatch({ type: PENDINGISSUE.GENERIC_REQUEST_REJECTED });
    raiseError(PENDINGISSUE.GENERIC_REQUEST_REJECTED, err.response.data);
  }
};

const getNextPendingIssueNo = (projectId) => async (dispatch) => {
  dispatch({ type: PENDINGISSUE.GENERIC_REQUEST });
  const apiEndpoint = `${BASE_URL}/api/PendingIssues/GetNextNumber/${projectId}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: PENDINGISSUE.GENERIC_REQUEST_FULFILLED });
    return res.data;
  } catch (err) {
    dispatch({ type: PENDINGISSUE.GENERIC_REQUEST_REJECTED });
    raiseError(PENDINGISSUE.GENERIC_REQUEST_REJECTED, err.response.data);
  }
};

const pendingIssueActions = {
  add,
  deletePendingIssue,
  getAll,
  getDetails,
  getNextPendingIssueNo,
  hasLinks,
  update,
};

export default pendingIssueActions;
